import React from 'react'

import ConversationHeader from 'app/ConversationPage/components/ConversationHeader'
import { useSETrackEvent } from 'app/ConversationPage/hooks/useSETrackEvent'
import {
  useConversationEntryPointStore,
  useConversationLandingOnboardingStore,
} from 'stores/conversation'
import ConversationLandingOnboardingPartOne from './ConversationLandingOnboardingPartOne'

const ConversationLandingStepOne = () => {
  const { entryPointVariant } = useConversationEntryPointStore()
  const { landingOnboardingVariant, setLandingOnboardingStep } =
    useConversationLandingOnboardingStore()
  const { SETrackConversationPage } = useSETrackEvent()

  return (
    <ConversationLandingOnboardingPartOne
      onClick={() => {
        setLandingOnboardingStep(1)
        SETrackConversationPage('CLICK_GURU_AI_INTRODUCTION_READY', {
          event_trigger: 'GURU_AI_INTRODUCTION_PAGE',
          screen_name: 'GURU_AI_INTRODUCTION_PAGE',
          source: `HOMEPAGE_${entryPointVariant}`,
          variant: landingOnboardingVariant,
        })
      }}
    />
  )
}

const ConversationLandingVariantB = () => {
  return (
    <>
      <ConversationHeader borderless />

      <main className="relative min-h-screen px-4 overflow-x-hidden">
        <section
          id="conversation-landing-variant-2"
          aria-label="Chatbot Landing page"
          className="w-full h-full pt-20 overflow-x-hidden overflow-y-auto pb-28"
        >
          <ConversationLandingStepOne />
        </section>
      </main>
    </>
  )
}

export default ConversationLandingVariantB
